import styled from "styled-components";

export const BodyStyled = styled.div`
    display: grid;
    grid-template-columns: 7fr 1fr;
    grid-gap: 20px;
`;

export const ActionsStyled = styled.div`

`;

export const StatusStyled = styled.div`

`;

export const StatusListStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
    justify-items: center;

    & > div {
        cursor: pointer;
    }
`;

export const CameraStyled = styled.div`
    h5 {
        margin: 0;
    }

    img {
        width: 100%;
    }
`;

export const CameraWrapperStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 13px;
`;

export const CameraItemsStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 13px;
`;


export const SummaryStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 30px;
`;

export const LabelStyled = styled.span`
    color: rgb(103, 116, 142);
    font-size: 13px;
    margin-right: 3px;
`;

export const GoToAlertStyled = styled.span`
    span {
        color: rgb(0, 121, 244);
        text-decoration: underline;
    }
`;

export const WrapperStyled = styled.div`
    background: rgb(248, 249, 250);
    padding: 20px;

    span, div {
        &.status-class-pouu {
            font-weight: bold;
        }

        &.ACTIVE {
            color: #0583ea;
        }

        &.CRITICAL {
            color: red;
        }

        &.HANDLED, &.INFO {
            color: green;
        }

        &.PENDING {
            color: #FDD547;
        }
    }
`;

export const ListWrapperStyled = styled.div`

`;

export const TitleWrapperStyled = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;

    .title-addition {
        margin-left: 5px;
    }
`;

export const ActionsWrapperStyled = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 15px;
`;

export const ActionItemStyled = styled.div`
    display: grid;
    grid-template-columns: 20% 20% 20%;
    grid-gap: 15px;
`;

export const GroundTruthStyled = styled.span`
    position: absolute;
    height: 100%;
    width: 100%;
    background: rgb(133 199 117 / 20%);
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;

    &.val-2 {
        background: rgb(255 0 0 / 20%);
    }
`;
export const GROUND_TRUTH_DATA = [
    'VALID',
    'INVALID'
];